import React, { useState, useEffect } from 'react';
import PressAddItem from './PressAddItem';
import PressList from './PressList';
import { useMode } from '../contexts/ModeContext';
import { Modal, Button } from 'react-bootstrap';

const Presss = () => {
    const [refreshList, setRefreshList] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { isModeAdmin } = useMode();

    const handleAddItem = () => {
        setRefreshList(!refreshList);
        setShowModal(false);
    };

    useEffect(() => {
        setRefreshList(false);
    }, [isModeAdmin]);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <PressList refreshList={refreshList}/>
            { isModeAdmin && (
                <>
                    <Button variant="primary" onClick={() => setShowModal(true)}>Ajouter un article de presse</Button>
                    <Modal show={showModal} onHide={handleCloseModal} size='xl'>
                        <Modal.Header closeButton>
                            <Modal.Title>Ajouter un article de presse</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <PressAddItem handleAddItem={handleAddItem} />
                        </Modal.Body>
                    </Modal>
                </>
            )}
        </>
    );
}

export default Presss;
